(function () {
  if (window.NgQuote) return;

  var KEY = 'ngQuoteItems';
  var MAX_ITEMS = 100;

  function keyOf(item) {
    return item.code || item.title;
  }

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* storage full or blocked: the list just isn't kept */
    }
    document.dispatchEvent(new CustomEvent('ngquote:change', { detail: { items: items } }));
  }

  function add(item) {
    var items = read();
    if (!items.some(function (i) { return keyOf(i) === keyOf(item); })) items.push(item);
    write(items);
    return items;
  }

  function remove(key) {
    var items = read().filter(function (i) { return keyOf(i) !== key; });
    write(items);
    return items;
  }

  function clear() {
    write([]);
  }

  // Saves a quantity without firing ngquote:change, so the quantity box keeps focus while typing.
  function setQty(key, qty) {
    var items = read();
    items.forEach(function (i) { if (keyOf(i) === key) i.qty = qty; });
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* storage full or blocked */
    }
  }

  window.NgQuote = { read: read, add: add, remove: remove, clear: clear, keyOf: keyOf, setQty: setQty };

  // Any element with data-ng-quote-add adds its product to the quote list.
  // data-ng-quote-stay keeps the visitor on the page; otherwise the link's href (the quote page) opens.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ng-quote-add]');
    if (!button) return;
    event.preventDefault();

    add({
      code: button.getAttribute('data-code') || '',
      title: button.getAttribute('data-title') || '',
      url: button.getAttribute('data-url') || ''
    });

    if (!button.hasAttribute('data-ng-quote-stay')) {
      window.location.href = button.getAttribute('href');
      return;
    }

    var label = button.getAttribute('data-label') || button.textContent;
    button.setAttribute('data-label', label);
    button.textContent = button.getAttribute('data-added-label') || 'Added';
    button.classList.add('is-added');
    clearTimeout(button._ngQuoteTimer);
    button._ngQuoteTimer = setTimeout(function () {
      button.textContent = label;
      button.classList.remove('is-added');
    }, 1500);
  });
})();
